
    <div class="container-fluid">
        <div class="container">
            <div class="row">
                <div class="card col-md-4">
                  <div class="card-body">
                    <h2 class="card-title">Card title</h2>
                    <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
                    <div class="icon">
                        <a href="#"><img src="../../../assets/img/icon/facebook.png" alt=""></a>
                        <a href="#"><img src="../../../assets/img/icon/gorjeo.png" alt=""></a>
                        <a href="#"><img src="../../../assets/img/icon/plus.png" alt=""></a>
                        <a href="#"><img src="../../../assets/img/icon/camara.png" alt=""></a>
                        <a href="#"><img src="../../../assets/img/icon/pinterest.png" alt=""></a>
                        <a href="#"><img src="../../../assets/img/icon/behance.png" alt=""></a>
                      </div>
                  </div>
                 
                </div>
                <div class="card col-md-4">
                  <div class="card-body">
                      <h2 class="card-title">Latest Twits</h2>
                 <ul>
                     <li><a href="#"><img src="../../../assets/img/icon/gorjeo.png" alt=""></a>Lorem ipsum dolor sit.</li>
                     <li><a href="#"><img src="../../../assets/img/icon/gorjeo.png" alt=""></a>Lorem ipsum dolor sit.</li>
                     <li><a href="#"><img src="../../../assets/img/icon/gorjeo.png" alt=""></a>Lorem ipsum dolor sit.</li>
                     <li><a href="#"><img src="../../../assets/img/icon/gorjeo.png" alt=""></a>Lorem ipsum dolor sit.</li>
                     <li><a href="#"><img src="../../../assets/img/icon/gorjeo.png" alt=""></a>Lorem ipsum dolor sit.</li>
                 </ul>
                  </div>
                </div>
                <div class="card col-md-4">
                    <h2 class="card-title uno">How to learn?</h2>
                  <div class="row  ">
                    <div class="row  size row-cols-md-3">
                        <div class="col-sm-4  mb-2">
                          <div class="card">
                            <img src="../../../assets/img/images2/image3.jpg" class="card-img-top" alt="...">
                          </div>
                        </div>
                        <div class="col-sm-4  mb-2">
                          <div class="card">
                            <img src="../../../assets/img/images/nueve.jpg" class="card-img-top" alt="...">
                          </div>
                        </div>
                        <div class="col-sm-4  mb-2">
                          <div class="card">
                            <img src="../../../assets/img/images2/image8.jpg" class="card-img-top" alt="...">
                          </div>
                        </div>
                    </div>
         
                  </div>
                  <div class="row  ">
                    <div class="row  size row-cols-md-3">
                        <div class="col-sm-4  mb-2">
                          <div class="card">
                            <img src="../../../assets/img/images/dos.jpg" class="card-img-top" alt="...">
                          </div>
                        </div>
                        <div class="col-sm-4  mb-2">
                          <div class="card">
                            <img src="../../../assets/img/images2/image1.jpg" class="card-img-top" alt="...">
                          </div>
                        </div>
                        <div class="col-sm-4  mb-2">
                          <div class="card">
                            <img src="../../../assets/img/images/cinco.jpg" class="card-img-top" alt="...">
                          </div>
                        </div>
                    </div>
         
                  </div>
                  </div>
                </div>
              </div>        
        </div>
  

       